import { Box, Container, Typography, Button, CircularProgress } from '@mui/material';
import { useParams, useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useProject } from '../../hooks/useProjects';
import { useProjectPodcasts } from '../../hooks/usePodcasts';
import { useYouTubeVideos } from '../../hooks/useYouTubeVideos';
import { ROUTES } from '../../config/constants';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { YouTubeVideoSection } from '@/components/youtube/YouTubeVideoSection';
import { PodcastEpisodeSection } from '@/components/podcasts/PodcastEpisodeSection';

export const ProjectDetail = () => {
  const { t } = useTranslation('projects');
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { project, isLoading } = useProject(Number(id));
  const { data: podcastsMap, isLoading: isPodcastsLoading } = useProjectPodcasts(Number(id));
  const { data: youtubeVideos } = useYouTubeVideos(Number(id));

  if (isLoading || isPodcastsLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!project) {
    return (
      <Container>
        <Typography variant="h5">{t('projectNotFound')}</Typography>
        <Button onClick={() => navigate(ROUTES.PROJECTS)}>{t('backToProjects')}</Button>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate(ROUTES.PROJECTS)}
        sx={{ mb: 3 }}
      >
        {t('backToProjects')}
      </Button>

      <Box mb={4}>
        <Typography variant="h4" component="h1" gutterBottom>
          {project.projectName}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t('learningLanguage', { language: project.projectLanguage })} • {t('yourLanguage', { language: project.userLanguage })}
        </Typography>
      </Box>

      {/* YouTube section — grouped by channel (Story 1.3) */}
      <YouTubeVideoSection projectId={Number(id)} videos={youtubeVideos ?? []} />

      {/* Podcasts section — grouped by podcast, mirrors YouTubeVideoSection layout */}
      <PodcastEpisodeSection
        projectId={Number(id)}
        podcastsMap={podcastsMap ?? {}}
        projectLanguage={project.projectLanguage}
      />
    </Container>
  );
};
